import script from "./ElementColorMask.vue?vue&type=script&lang=ts&setup=true"
export * from "./ElementColorMask.vue?vue&type=script&lang=ts&setup=true"

import "./ElementColorMask.vue?vue&type=style&index=0&id=7e9086fc&lang=scss&scoped=true"

import exportComponent from "C:\\work\\to-create\\bailing\\yc-bailing-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e9086fc"]])

export default __exports__